// import React, { useState } from "react";

// const columns = [
//   {
//     key: "operational",
//     displayName: "Operational",
//   },
//   {
//     key: "operational_plus",
//     displayName: "Operational+",
//   },
//   {
//     key: "specialized",
//     displayName: "Specialized",
//   },
//   {
//     key: "specialized_plus",
//     displayName: "Specialized+",
//   },
//   {
//     key: "supervisory",
//     displayName: "Supervisory",
//   },
// ];

// const rows = [
//   {
//     key: "on_the_job",
//     title: "On-the-Job",
//     description:
//       "Hands-on experience, mostly on-the-job training with limited/other skill qualifications",
//   },
//   {
//     key: "vocational",
//     title: "Vocational",
//     description: "Received vocational training and/or apprenticeship",
//   },
//   {
//     key: "certified",
//     title: "Certified",
//     description:
//       "Received professional certification or works in a highly regulated role",
//   },
// ];

// const BlueCollar = () => {
//   const [selectedCell, setSelectedCell] = useState(null);

//   const handleSelection = (trainingExperience, natureOfWork) => {
//     const selectedValue = {
//       training_experience: trainingExperience,
//       nature_of_work: natureOfWork,
//     };

//     setSelectedCell(selectedValue);
//     console.log(selectedValue);
//   };

//   return (
//     <div className="bg-white p-4 rounded shadow">
//       <h3 className="font-semibold text-textModal text-2xl leading-10 text-center">
//         Blue Collar
//       </h3>

//       <div className="overflow-x-auto mt-10">
//         <table className="w-full border-collapse">
//           <thead>
//             <tr>
//               <th colSpan={2}></th>

//               <th
//                 colSpan={5}
//                 className="text-center text-gray-600 text-lg font-bold pb-3"
//               >
//                 NATURE OF WORK
//               </th>
//             </tr>

//             <tr>
//               <th colSpan={2}></th>

//               {columns.map(column => (
//                 <th
//                   key={column.key}
//                   className="bg-bgSidebar text-white font-semibold text-center border border-white py-3 px-3"
//                 >
//                   {column.displayName}
//                 </th>
//               ))}
//             </tr>

//             <tr>
//               <th colSpan={2}></th>

//               <th
//                 colSpan={2}
//                 className="bg-gray-200  text-xs font-medium text-center border border-white p-4"
//               >
//                 Physical or manual labour, and/or operational work
//               </th>

//               <th
//                 colSpan={2}
//                 className="bg-gray-200  text-xs font-medium text-center border border-white p-4"
//               >
//                 Specialized/multi trade or hybrid work.
//               </th>

//               <th className="bg-gray-200  text-xs font-medium text-center border border-white p-4">
//                 Has supervisory responsibilities over a team.
//               </th>
//             </tr>
//           </thead>

//           <tbody>
//             <tr>
//               <td
//                 colSpan={2}
//                 className="font-bold text-gray-600 text-left py-3"
//               >
//                 TRAINING / EXPERIENCE
//               </td>

//               <td colSpan={5} className="bg-gray-50"></td>
//             </tr>

//             {rows.map(row => (
//               <tr key={row.key}>
//                 <td className="bg-bgSidebar text-white font-bold border border-white px-4 py-4 w-40">
//                   {row.title}
//                 </td>

//                 <td className="bg-gray-200 text-sm  border border-white px-4 py-4 w-72">
//                   {row.description}
//                 </td>

//                 {columns.map(column => {
//                   const isSelected =
//                     selectedCell?.training_experience === row.key &&
//                     selectedCell?.nature_of_work === column.key;

//                   return (
//                     <td
//                       key={`${row.key}-${column.key}`}
//                       className="bg-gray-50 border border-white text-center px-6 py-5"
//                     >
//                       <input
//                         type="radio"
//                         name="blue-collar-matrix"
//                         checked={isSelected}
//                         onChange={() =>
//                           handleSelection(row.key, column.key)
//                         }
//                         className="w-5 h-5 cursor-pointer"
//                       />
//                     </td>
//                   );
//                 })}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default BlueCollar;

import React from "react";

const columns = [
  {
    key: "operational",
    displayName: "Operational",
  },
  {
    key: "operational_plus",
    displayName: "Operational+",
  },
  {
    key: "specialized",
    displayName: "Specialized",
  },
  {
    key: "specialized_plus",
    displayName: "Specialized+",
  },
  {
    key: "supervisory",
    displayName: "Supervisory",
  },
];

const rows = [
  {
    key: "on_the_job",
    title: "On-the-Job",
    description:
      "Hands-on experience, mostly on-the-job training with limited/other skill qualifications",
  },
  {
    key: "vocational",
    title: "Vocational",
    description: "Received vocational training and/or apprenticeship",
  },
  {
    key: "certified",
    title: "Certified",
    description:
      "Received professional certification or works in a highly regulated role",
  },
];

const BlueCollar = ({ value, onChange }) => {
  const handleSelection = (trainingExperience, natureOfWork) => {
    onChange({
      training_experience: trainingExperience,
      nature_of_work: natureOfWork,
    });
  };

  return (
    <div className="bg-white p-4 rounded shadow">
      <h3 className="font-semibold text-textModal text-2xl leading-10 text-center">
        Blue Collar
      </h3>

      <div className="overflow-x-auto mt-10">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th colSpan={2}></th>

              <th
                colSpan={5}
                className="text-center text-textModal font-bold pb-3"
              >
                Nature of Work
              </th>
            </tr>

            <tr>
              <th colSpan={2}></th>

              {columns.map(column => (
                <th
                  key={column.key}
                  className="bg-bgSidebar text-white font-semibold text-center border border-white py-3 px-3"
                >
                  {column.displayName}
                </th>
              ))}
            </tr>

            <tr>
              <th colSpan={2}></th>

              <th
                colSpan={2}
                className="bg-gray-200  text-xs font-medium text-center border border-white p-4"
              >
                Physical or manual labour, and/or operational work
              </th>

              <th
                colSpan={2}
                className="bg-gray-200  text-xs font-medium text-center border border-white p-4"
              >
                Specialized/multi trade or hybrid work.
              </th>

              <th className="bg-gray-200  text-xs font-medium text-center border border-white p-4">
                Has supervisory responsibilities over a team.
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td
                colSpan={2}
                className="font-bold text-left py-3 text-textModal"
              >
                Training / Experience
              </td>

              <td colSpan={5} className="bg-bgJobEvaSmCard "></td>
            </tr>

            {rows.map(row => (
              <tr key={row.key}>
                <td className="bg-bgSidebar text-white font-semibold border border-white p-4 w-32 text-center">
                  {row.title}
                </td>

                <td className="bg-gray-200 text-xs border border-white p-4 ">
                  {row.description}
                </td>

                {columns.map(column => {
                  const isSelected =
                    value?.training_experience === row.key &&
                    value?.nature_of_work === column.key;

                  return (
                    <td
                      key={`${row.key}-${column.key}`}
                      className="bg-bgJobEvaSmCard  border border-white text-center"
                    >
                      <input
                        type="radio"
                        name="blue-collar-matrix"
                        checked={isSelected}
                        onChange={() => handleSelection(row.key, column.key)}
                        className="w-5 h-5 cursor-pointer"
                      />
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BlueCollar;
